import axios from 'axios';
import { SHIWA_JSON_OUTPUT_DIR } from '../applications/news/constants/constants';
const newsBackendPrefix = '/apps/composite/api/news';
// indítás: cd /application/composite, mvn spring-boot:run
export default {
	/**
	 * @param params -> tag, start (default:10), rows (default:0)
	 * @returns {AxiosPromise}
	 */
	getNews(params) {
		return axios.get(newsBackendPrefix, { params });
	},
	getTags(params) {
		return axios.get(newsBackendPrefix + '/tags', { params });
	},
	getJsonData() {
		return axios.get(`${SHIWA_JSON_OUTPUT_DIR}premium-newsletters.json`);
	}
};
